module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "l-container"
  }, [_c('h1', {
    staticClass: "m-label"
  }, [_vm._v("家庭ファイル")]), _vm._v(" "), _c('tr-c', {
    attrs: {
      "slot": "tr-th"
    },
    slot: "tr-th"
  }, [_c('th-c', [_vm._v("id")]), _vm._v(" "), _c('th-c', [_vm._v("family_id")]), _vm._v(" "), _c('th-c', [_vm._v("user_id")]), _vm._v(" "), _c('th-c', [_vm._v("ファイル名")]), _vm._v(" "), _c('th-c', [_vm._v("作成日")])], 1), _vm._v(" "), _c('tr-c', {
    attrs: {
      "slot": "tr-td"
    },
    slot: "tr-td"
  }, [_c('td-c', [_vm._v(_vm._s(_vm.familyfile.id))]), _vm._v(" "), _c('td-c', [_vm._v(_vm._s(_vm.familyfile.family_id))]), _vm._v(" "), _c('td-c', [_vm._v(_vm._s(_vm.familyfile.user_id))]), _vm._v(" "), _c('td-c', [_vm._v(_vm._s(_vm.familyfile.file_name))]), _vm._v(" "), _c('td-c', [_vm._v(_vm._s(_vm.familyfile.created_at))])], 1)], 1), _vm._v(" "), (_vm.familyfile.id) ? [_c('iframe', {
    attrs: {
      "src": _vm.files + _vm.familyfile.id + '_f.pdf',
      "frameborder": "0"
    }
  })] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-782b3fdb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/Familyfile/Familyfile.vue
// module id = 1422
// module chunks = 0